<template>
  <!-- Modal -->
  <div ref="modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h5 class="modal-title">Edit Interview</h5>
          <button type="button" class="close" aria-label="Close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <ErrorSummary :error="error" />
          <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
            <div class="form-group">
              <label>Language</label>
              <select v-model="languageCode" class="form-control" :disabled="loadingMessage" required>
                <option value="en">English</option>
                <option value="es">Spanish</option>
              </select>
              <div class="invalid-feedback">Please select a language.</div>
            </div>
            <div class="form-group">
              <div class="form-check-inline" data-bs-toggle="tooltip" data-bs-delay="500" title="Provide test taker extra time to answer each question">
                <label class="form-check-label" for="extendedTime">
                  Extended Time
                </label>
                <input v-model="extendedTime" id="extendedTime" class="form-check-input m-2" type="checkbox" :disabled="loadingMessage" />
              </div>
            </div>
            <div v-if="extendedTime" class="form-group">
              <input
                v-model="extendedTimeReason"
                type="text"
                id="extendedTimeReason"
                class="form-control"
                placeholder="Reason for Extension"
                :disabled="loadingMessage"
                maxlength="255"
                required
              />
              <div class="invalid-feedback">Please provide a reason for extended time.</div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="submit">Save</button>
          <button type="button" class="btn btn-primary" @click="closeModal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import ErrorSummary from "@/components/ErrorSummary.vue";

export default {
  components: {
    ErrorSummary,
  },
  props: {
    isLoading: Boolean,
    investigation: Object,
  },
  data() {
    return {
      loadingMessage: null,
      formWasValidated: false,
      error: null,

      interview: null,

      extendedTime: null,
      extendedTimeReason: null,
      languageCode: null,
    };
  },
  methods: {
    showModal(interview) {
      this.interview = interview;
      this.extendedTime = interview.extendedTime;
      this.extendedTimeReason = interview.extendedTimeReason;
      this.languageCode = interview.languageCode;

      $(this.$refs.modal).modal("show");
    },
    closeModal() {
      this.reset();
      $(this.$refs.modal).modal("hide");
    },
    reset() {
      this.error = null;
      this.loadingMessage = null;
    },
    async submit() {
      // reset
      this.reset();

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        return;
      }

      // payload
      var payload = {
        extendedTime: this.extendedTime,
        extendedTimeReason: this.extendedTimeReason,
        languageCode: this.languageCode,
      };

      // api
      this.loadingMessage = "Saving...";
      this.$axios
        .put(
          `/v1/organizations/${this.investigation.organizationId}/investigations/${this.investigation.investigationId}/interviews/${this.interview.organizationInvestigationInterviewId}`,
          payload
        )
        .catch(err => (this.error = err))
        .then(() => {
          this.closeModal();
          this.reset();
          this.$emit("reload");
        })
        .finally(() => (this.loadingMessage = null));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";
</style>
